module.exports = __webpack_public_path__ + "static/media/rsz_astar.97a655ac.webp";